import {useMutation, useQueryClient} from '@tanstack/react-query';
import shipmentUpdaters from '@/api/updaters/shipments';

function useShipShipment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['shipments', 'ship'],
    mutationFn: shipmentUpdaters.ship,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useShipShipment;
